export const APP_WCRS_DEV = 'https://dev-wcrs.familycare.ai/home'
export const APP_WCRS_PROD = 'https://n-wcrs.familycare.ai/home'
export const APP_STORE_WARD = 'https://play.google.com/store/apps/details?id=co.kr.datau.tesla_p'
export const IOS_APP_STORE_WARD = 'https://tesla.onelink.me/pIMw/b9qbsh3i'
export const DATAU_HOMEPAGE = 'https://www.datauniverse.co.kr'
export const MO_APP_STORE_WARD = 'https://tesla.onelink.me/pIMw/bz184gcz'
export const IMAGE_SERVER_DEV = 'https://dev-img.familycare.ai'
export const IMAGE_SERVER_PROD = 'https://img.familycare.ai'
export const SERVICE_CANCEL_HOST = 'servicecancel'
export const SERVICE_JOIN_URL = 'https://s.familycare.ai/b557fe'
